import ApiService from '@/core/services/ApiService';
import { Actions, Mutations } from '@/store/enums/StoreEnums';
import { Module, Action, Mutation, VuexModule } from 'vuex-module-decorators';

export interface PropertyTypeObject {
  id: number;
  titleEn: string;
  titleAr: string;
  icon: string;
  sort: string;
  isActive: boolean;
}

export interface PropertyTypesListInfo {
  totalItems: number;
  currentPage: number;
  pageSize: number;
  isNext: boolean;
  previous: number;
  types: Array<PropertyTypeObject>;
  errors: unknown;
}

@Module
export default class PropertyTypesModule
  extends VuexModule
  implements PropertyTypesListInfo
{
  types = [] as Array<PropertyTypeObject>;
  allTypes = [] as Array<PropertyTypeObject>;
  totalItems = 0;
  currentPage = 1;
  pageSize = 10;
  previous = 0;
  isNext = true;
  errors = {};

  /**
   * Get types list
   * @returns Array<PropertyTypeObject>
   */
  get auctionPropertyTypesList(): Array<PropertyTypeObject> {
    return this.types;
  }

  /**
   * Get all types list
   * @returns Array<PropertyTypeObject>
   */
  get allAuctionPropertyTypes(): Array<PropertyTypeObject> {
    return this.allTypes;
  }

  /**
   * Get total items
   * @returns number
   */
  get auctionPropertyTypesListCount(): number {
    return this.totalItems;
  }

  @Mutation
  [Mutations.SET_AUCTION_PROPERTY_TYPES](data) {
    this.types = data.data;
    this.totalItems = data.totalItems;
    this.currentPage = data.currentPage;
    this.pageSize = data.pageSize;
    this.isNext = data.isNext;
    this.previous = data.previous;
    this.errors = {};
  }

  @Mutation
  [Mutations.SET_ALL_AUCTION_PROPERTY_TYPES](data) {
    this.allTypes = data.data;
  }

  @Mutation
  [Mutations.SET_AUCTION_PROPERTY_TYPE_CURRENT_PAGE](page) {
    this.currentPage = page;
  }

  @Mutation
  [Mutations.RESET_AUCTION_PROPERTY_TYPES_LIST]() {
    this.types = [] as Array<PropertyTypeObject>;
    this.totalItems = 0;
    this.currentPage = 1;
    this.pageSize = 10;
    this.previous = 0;
    this.isNext = true;
    this.errors = {};
  }

  @Action
  [Actions.RESET_AUCTION_PROPERTY_TYPES_STORE]() {
    this.context.commit(Mutations.RESET_AUCTION_PROPERTY_TYPES_LIST);
  }

  @Action
  [Actions.CREATE_AUCTION_PROPERTY_TYPE](data) {
    ApiService.setAuthorizationHeader();
    return ApiService.post('/auctions-assets/property-types', data)
      .then((response) => {
        this.context.commit(Mutations.RESET_AUCTION_PROPERTY_TYPES_LIST);
        return response.data;
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.SET_ERROR, {
          [response.statusText]: [response.data.message],
        });
      });
  }

  @Action
  [Actions.DELETE_AUCTION_PROPERTY_TYPE](id) {
    ApiService.setAuthorizationHeader();
    return ApiService.delete('/auctions-assets/property-types', id)
      .then(() => {
        this.context.commit(Mutations.RESET_AUCTION_PROPERTY_TYPES_LIST);
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.SET_ERROR, {
          [response.statusText]: [response.data.message],
        });
      });
  }

  @Action
  [Actions.UPDATE_AUCTION_PROPERTY_TYPE]({ id, data }) {
    ApiService.setAuthorizationHeader();
    return ApiService.update('/auctions-assets/property-types', id, data)
      .then((response) => {
        this.context.commit(Mutations.RESET_AUCTION_PROPERTY_TYPES_LIST);
        return response.data;
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.SET_ERROR, {
          [response.statusText]: [response.data.message],
        });
      });
  }

  @Action
  [Actions.UPDATE_AUCTION_PROPERTY_TYPE_CURRENT_PAGE](val) {
    this.context.commit(Mutations.SET_AUCTION_PROPERTY_TYPE_CURRENT_PAGE, val);
  }

  @Action
  [Actions.GET_AUCTION_PROPERTY_TYPE](id) {
    ApiService.setAuthorizationHeader();
    return ApiService.get('/auctions-assets/property-types', id);
  }

  @Action
  [Actions.GET_ALL_AUCTION_PROPERTY_TYPES]() {
    ApiService.setAuthorizationHeader();
    return ApiService.get('/auctions-assets/property-types/all')
      .then(({ data }) => {
        this.context.commit(Mutations.SET_ALL_AUCTION_PROPERTY_TYPES, data);
      })
      .catch(({ response }) => {
        console.error(response);
        // this.context.commit(Mutations.SET_ERROR, {
        //   [response.statusText]: [response.data.message],
        // });
      });
  }
  @Action
  [Actions.GET_AUCTION_PROPERTY_TYPES]() {
    ApiService.setAuthorizationHeader();
    const params = { page: this.currentPage, limit: 10 };
    return ApiService.query('/auctions-assets/property-types', { params })
      .then(({ data }) => {
        this.context.commit(Mutations.SET_AUCTION_PROPERTY_TYPES, data);
      })
      .catch(({ response }) => {
        console.error(response);
        // this.context.commit(Mutations.SET_ERROR, {
        //   [response.statusText]: [response.data.message],
        // });
      });
  }

  @Action
  [Actions.UPLOAD_PROPERTY_TYPE_ICON]({ data, id }) {
    ApiService.setAuthorizationHeader();
    ApiService.setMultipartHeader();
    return ApiService.post(
      `/auctions-assets/property-types/uploadIcon/${id}`,
      data
    )
      .then(({ data }) => {
        return data.data;
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.SET_ERROR, {
          [response.statusText]: [response.data.message],
        });
      });
  }
}
